// [PHASE 1 — 1b] COLOR_CODE + useSetCSSVariables were removed. All colours now
// come from the DS ThemeProvider semantic tokens (var(--color-*)). Do not
// reintroduce a parallel hardcoded-hex colour system here.

export const COLOR = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
}
export const TAG_COLOR = {
  CYAN_500: 'blue',
  CYAN_700: 'blue',
  GRAY_100: 'gray',
  GRAY_500: 'gray',
  GREEN_150: 'green',
  GREEN_600: 'green',
  ORANGE_150: 'orange',
  ORANGE_400: 'orange',
  RED_150: 'red',
  RED_600: 'red',
  YELLOW_150: 'orange',
  YELLOW_400: 'orange',
  AUXILIARY_300: 'blue',
  AUXILIARY_600: 'blue'
}